// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"aac6f939","486":"4e2a1a0e","633":"5072a4d4"}[chunkId] + ".chunk.css";
};